<template>
  <EntityList
    ref="answersList"
    :config="config"
    :custom-query="customQuery"
    :columns="columns"
    :filter-vals="filterVals"
    :filters="filters"
    :formatted-columns="formattedColumns"
    :allow-duplicate="false"
    :export-extra-columns="{
      extraColumns: extraColumns,
      key: 'fields',
      parent: 'field',
    }"
    :extra-actions="extraActions"
    :has-insert-btn="id > 0"
    authority="Poll_Management_Answer"
    single-edit
    allow-edit-columns
    desc-sort
    @filtersUpdated="filtersUpdated"
  />
</template>

<script>
import { getUserRights } from '@/auth/utils'
import EntityList from '@/layouts/entity/EntityList.vue'
import store from '@/store'
import storeModule from './storeModule'

export default {
  components: {
    EntityList,
  },
  data() {
    return {
      filterVals: [],
      pollOptions: [],
      categoryOptions: [],
      userOptions: [],
      extraColumns: [],
    }
  },
  computed: {
    id() {
      return this.$route.params.id
    },
    config() {
      return {
        store: storeModule,
        module: 'poll-responses',
        endpoint: 'poll-responses',
        route: 'responses',
        insertRoute: { name: `answers-edit`, params: { qid: this.id } },
        title: {
          single: this.$t('poll Add'),
          plural: this.$t('polls'),
        },
      }
    },
    columns() {
      return [
        { key: 'id', label: this.$t('id'), sortable: true },
        {
          key: 'poll.title',
          label: this.$t('pollType'),
          sortable: true,
        },
        { key: 'user.title', label: this.$t('User'), sortable: false },
        { key: 'creationDate', label: this.$t('Date'), sortable: true },
        { key: 'publishDate', label: this.$t('Publish Date'), sortable: true },
        { key: 'comments', label: this.$t('comments'), visible: false },
        { key: 'actions', label: this.$t('actions') },
      ]
    },
    formattedColumns() {
      return [
        { key: 'creationDate', type: 'date' },
        { key: 'publishDate', type: 'date' },
      ]
    },
    customQuery() {
      if (this.id) {
        return { poll: this.id }
      }
      return {}
    },
    filters() {
      let filters = [
        {
          name: 'category',
          label: this.$t('Category'),
          options: this.categoryOptions,
        },
      ]
      if (!this.id) {
        filters.push({
          name: 'poll',
          label: this.$t('poll'),
          options: this.pollOptions,
        })
      }
      return [
        ...filters,
        ...[
          {
            name: 'user',
            label: this.$t('User'),
            options: this.userOptions,
          },
          {
            name: 'startDate',
            type: 'date',
            label: this.$t('Start Date'),
            maxDateFieldIdx: '2',
          },
          {
            name: 'endDate',
            type: 'date',
            label: this.$t('End Date'),
            minDateFieldIdx: '1',
          },
        ],
      ]
    },
    extraActions() {
      const isManager = getUserRights().includes('Poll_Management_Poll_Edit')
      return [
        {
          callback: 'getEditLink',
          icon: 'EyeIcon',
          title: 'View',
          renderCondition: {
            key: 'published',
            value: true,
          },
          propertyNotExists: 'finalized',
          authorityValidation: !isManager
        },
        {
          callback: 'getEditLink',
          icon: 'Edit3Icon',
          title: 'Edit',
          variant: 'success',
          renderCondition: {
            key: 'published',
            value: true,
          },
          propertyNotExists: 'finalized',
          authorityValidation: isManager
        },
        {
          callback: 'getEditLink',
          icon: 'EyeIcon',
          title: 'View',
          renderCondition: {
            key: 'finalized',
            value: true,
          },
          authorityValidation: isManager
        },
      ]
    },
  },
  mounted() {
    store.dispatch('app-common/fetchPollCategories').then(response => {
      this.categoryOptions = response.data
    })
    if (!this.id) {
      store.dispatch('app-common/fetchPolls').then(response => {
        this.pollOptions = response.data
        this.$refs.answersList.updateFilterValues(
          this.pollOptions[0].id,
          1,
        )
      })
    } else {
      this.fetchExtraFields(this.id)
    }
    store
      .dispatch('app-common/fetchUsers', { secondarygroup: 15 })
      .then(response => {
        this.userOptions = response.data
      })
  },
  methods: {
    filtersUpdated(filters) {
      if (!this.id && filters[1]) {
        this.fetchExtraFields(filters[1])
      }
    },
    fetchExtraFields(pollId) {
      store
        .dispatch('app-common/fetchPollPlainFields', pollId)
        .then(response => {
          this.extraColumns = response.data
        })
    },
  },
}
</script>
